import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import toast from 'react-hot-toast';
import { Box, Typography, Button, 
  Dialog, DialogTitle, DialogContent, DialogActions 
} from "@mui/material";

const CheckResultDialog = ({ 
  open, 
  onClose, 
  title = "Check", 
  checksList = [], 
  descriptionKey = "error", 
}) => {
  const handleExportChecks = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Errors');

      // Build the header row
      const headers = [...Object.keys(checksList[0])];
      worksheet.addRow(headers);

      // Add error rows
      checksList.forEach((check) => {
        const row = headers.map((header) => check[header] ?? '');
        worksheet.addRow(row);
      });

      // Auto width for all columns
      worksheet.columns.forEach(column => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, cell => {
          maxLength = Math.max(maxLength, (cell.value ? cell.value.toString().length : 0));
        });
        column.width = maxLength + 2;
      });

      // Create file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      // Save file
      const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "").slice(0, 14);
      const fileName = `Checks_${timestamp}.xlsx`;
      saveAs(blob, fileName);
    } catch (error) {
      toast.error(error?.message || "Failed to export to Excel!");
    }
  };


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{title} {checksList.length > 0 && `${checksList.length} issues`}</DialogTitle>
      <DialogContent dividers>
        {checksList.length === 0 ? (
          <Typography>No checks found.</Typography>
        ) : (
          <Box display="flex" flexDirection="column" gap={2}>
            {checksList?.map((check, index) => (
              <Box key={index} p={2} border={1} borderRadius={2} borderColor="primary.main">
                {Object.keys(check).map((key) => {
                  if (!key.includes(descriptionKey)) {
                    return (
                      <Typography key={key} variant="body2">
                        <strong>{key.replace(/([A-Z])/g, ' $1').trim()}:</strong> {String(check[key])}
                      </Typography>
                    );
                  }
                  return null;
                })}
                <Typography variant="body2" color="warning" mt={1}>
                  <strong>Result:</strong> {check[descriptionKey] || check.error}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={handleExportChecks} 
          variant="outlined" 
          color="success"
          disabled={checksList.length === 0}
        >
          Excel
        </Button>
        <Button onClick={onClose} variant="outlined" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CheckResultDialog;
